import { render, staticRenderFns } from "./Stevia-Sweet.vue?vue&type=template&id=49804ec7&scoped=true"
import script from "./Stevia-Sweet.vue?vue&type=script&lang=js"
export * from "./Stevia-Sweet.vue?vue&type=script&lang=js"
import style0 from "./Stevia-Sweet.vue?vue&type=style&index=0&id=49804ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49804ec7",
  null
  
)

export default component.exports